import React from "react";
import { Phone } from "lucide-react";

const PHONE = "2310225855";

export const FloatingCallButton = () => (
    <a
        href={`tel:${PHONE}`}
        data-testid="floating-call-btn"
        aria-label="Κάλεσέ μας"
        className="fixed bottom-6 left-6 z-40 group flex items-center gap-2 bg-brand-red hover:bg-brand-redhover text-white px-4 py-3 rounded-full shadow-2xl shadow-brand-red/30 transition-all hover:scale-105 active:scale-95"
    >
        <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
        </span>
        <Phone size={16} className="ml-1" />
        <span className="font-heading uppercase tracking-wider text-xs hidden sm:inline">Κάλεσε τώρα</span>
    </a>
);
